// components/business/BusinessCardResponsive.tsx
import React, { useMemo } from "react";
import { useWindowDimensions } from "react-native";

import LaptopMockup from "@/components/ui/LaptopMockup";
import type { Business } from "@/lib/types";

import BusinessCardDesktop from "./BusinessCardDesktop";
import BusinessCardMobile from "./BusinessCardMobile";
import type { BusinessCardActionHandler } from "./usePublicBusinessCardActions";

type Props = {
  business: Business;
  onShare?: BusinessCardActionHandler;
  onSave?: BusinessCardActionHandler;
  onDownload?: BusinessCardActionHandler;
};

export default function BusinessCardResponsive({
  business,
  onShare,
  onSave,
  onDownload,
}: Props) {
  const { width } = useWindowDimensions();

  const isDesktop = useMemo(() => width >= 1024, [width]);

  if (isDesktop) {
    return (
      <LaptopMockup>
        <BusinessCardDesktop
          business={business}
          onShare={onShare}
          onSave={onSave}
          onDownload={onDownload}
        />
      </LaptopMockup>
    );
  }

  return (
    <BusinessCardMobile
      business={business}
      onShare={onShare}
      onSave={onSave}
      onDownload={onDownload}
    />
  );
}
